// All-Access subscription checkout: plan selection, estimate refresh, and
// Cashfree mandate (autopay) checkout. Every subscription rides a mandate —
// the backend returns a subscription_session_id and the Cashfree JS SDK's
// subscriptionsCheckout collects the authorization. Activation is confirmed
// by the backend webhook; the return page only displays progress.
// Activated only on /payment/subscribe pages.
(function () {
    'use strict';

    if (window.location.pathname !== '/payment/subscribe') return;

    var page = document.querySelector('.subscribe-page');
    if (!page) return;

    // KYC-pending variant: details are on file, Aadhaar DigiLocker still
    // pending — fetch a fresh consent link and hand the student over.
    var kycBtn = document.getElementById('subscribe-kyc-btn');
    if (kycBtn) {
        kycBtn.addEventListener('click', function () {
            kycBtn.disabled = true;
            kycBtn.textContent = 'Preparing DigiLocker…';
            fetch('/api/student/subscription_kyc', { method: 'POST', credentials: 'same-origin' })
                .then(function (resp) { return resp.json(); })
                .then(function (body) {
                    var data = (body && body.data) || {};
                    if (body && body.status === 1 && data.kyc_state === 'verified') {
                        window.location.reload();
                        return;
                    }
                    if (body && body.status === 1 && data.consent_url && /^https:\/\//i.test(data.consent_url)) {
                        window.location.href = data.consent_url;
                        return;
                    }
                    kycBtn.disabled = false;
                    kycBtn.textContent = 'Verify with DigiLocker';
                    var note = document.getElementById('subscribe-kyc-note');
                    if (note) note.textContent = (body && body.error) || 'Could not start DigiLocker. Please try again shortly.';
                })
                .catch(function () {
                    kycBtn.disabled = false;
                    kycBtn.textContent = 'Verify with DigiLocker';
                });
        });
    }

    var planGroup     = document.getElementById('subscribe-plan-group');
    var subscribeBtn  = document.getElementById('subscribe-btn');
    var processing    = document.getElementById('subscribe-processing');
    var errorBox      = document.getElementById('subscribe-error');
    var errorMsg      = document.getElementById('subscribe-error-msg');
    var retryBtn      = document.getElementById('subscribe-retry-btn');
    var summary       = document.getElementById('subscribe-summary');

    // Manage-panel variant of the page has no form — nothing to wire.
    if (!planGroup || !subscribeBtn) return;

    // Set by subscribe.php when the Cashfree mandate gateway is available.
    var autopayGateway = page.dataset.autopayGateway || '';

    var estimateTimer = null;
    var busy = false;

    function selectedPlan() {
        var input = planGroup.querySelector('input[name="subscription_plan"]:checked');
        return input ? input.value : null;
    }
    function syncActiveCards() {
        planGroup.querySelectorAll('.subscribe-page__plan-card').forEach(function (card) {
            var input = card.querySelector('input[name="subscription_plan"]');
            card.classList.toggle('active', !!(input && input.checked));
        });
    }

    function showError(msg) {
        if (errorBox) errorBox.classList.remove('d-none');
        if (errorMsg) errorMsg.textContent = msg;
    }
    function hideError() {
        if (errorBox) errorBox.classList.add('d-none');
    }
    function setBusy(state) {
        busy = state;
        subscribeBtn.disabled = state || !isSelectionComplete();
        if (processing) processing.classList.toggle('d-none', !state);
    }

    function isSelectionComplete() {
        return !!selectedPlan() && !!autopayGateway;
    }
    function refreshButtonState() {
        if (!busy) subscribeBtn.disabled = !isSelectionComplete();
    }

    function formatMoney(value) {
        var num = parseFloat(value);
        if (isNaN(num)) num = 0;
        var digits = Number.isInteger(num) ? 0 : 2;
        return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: digits, maximumFractionDigits: 2 });
    }
    function formatDate(value) {
        if (!value) return '';
        var date = new Date(value);
        if (isNaN(date.getTime())) return value;
        return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    }

    // --- Estimate refresh (debounced on plan change) ---
    function refreshEstimate() {
        var plan = selectedPlan();
        if (!plan) return;

        if (summary) summary.classList.add('subscribe-page__summary--loading');

        var url = '/api/payment/subscription_estimate?plan=' + encodeURIComponent(plan);

        fetch(url, {
            method: 'GET',
            credentials: 'same-origin'
        })
        .then(function (resp) {
            return resp.json().then(function (body) {
                return { ok: resp.ok, body: body };
            });
        })
        .then(function (result) {
            if (summary) summary.classList.remove('subscribe-page__summary--loading');

            // A newer selection may have superseded this request.
            if (plan !== selectedPlan()) return;

            if (!result.ok || !result.body || result.body.status === 0 || !result.body.data) {
                showError((result.body && result.body.error) || 'Unable to refresh the payment estimate.');
                return;
            }

            hideError();
            var estimate = result.body.data;

            var sumAmount = document.getElementById('sum-amount');
            var sumPeriod = document.getElementById('sum-period');
            var sumRenewal = document.getElementById('sum-next-renewal');

            if (sumAmount) {
                var amountText = formatMoney(estimate.base_price) + ' + ' + formatMoney(estimate.tax_amount)
                    + ' GST (' + parseFloat(estimate.tax_percent || 0) + '%) = ' + formatMoney(estimate.amount);
                if (parseFloat(estimate.discount_percent || 0) > 0) {
                    amountText += ' — ' + parseFloat(estimate.discount_percent) + '% off, you save ' + formatMoney(estimate.savings);
                }
                sumAmount.textContent = amountText;
            }
            if (sumPeriod) {
                sumPeriod.textContent = formatDate(estimate.period_end) + ' ';
                var periodNote = document.createElement('small');
                periodNote.textContent = '(access through the whole day)';
                sumPeriod.appendChild(periodNote);
            }
            if (sumRenewal) {
                sumRenewal.textContent = formatDate(estimate.next_renewal_date) + ' at ' + formatMoney(estimate.renewal_amount) + ' (auto-debited)';
            }
        })
        .catch(function (err) {
            if (summary) summary.classList.remove('subscribe-page__summary--loading');
            console.error('Subscription estimate failed:', err);
            showError('Network error while refreshing the estimate.');
        });
    }

    planGroup.addEventListener('change', function (event) {
        if (!event.target || event.target.name !== 'subscription_plan') return;

        syncActiveCards();
        refreshButtonState();
        clearTimeout(estimateTimer);
        estimateTimer = setTimeout(refreshEstimate, 350);
    });

    if (retryBtn) {
        retryBtn.addEventListener('click', function () {
            hideError();
            setBusy(false);
        });
    }

    // --- Checkout (Cashfree mandate authorization) ---
    subscribeBtn.addEventListener('click', function () {
        if (busy || !isSelectionComplete()) return;

        hideError();
        setBusy(true);

        var params = 'plan=' + encodeURIComponent(selectedPlan())
            + '&renewal_mode=' + encodeURIComponent('Auto Debit')
            + '&mandate_gateway=' + encodeURIComponent(autopayGateway);

        fetch('/api/payment/subscription_initiate?' + params, {
            method: 'POST',
            credentials: 'same-origin'
        })
        .then(function (resp) {
            return resp.json().then(function (body) {
                return { ok: resp.ok, body: body };
            });
        })
        .then(function (result) {
            if (!result.ok || !result.body || result.body.status === 0 || !result.body.data) {
                setBusy(false);
                showError((result.body && result.body.error) || 'Unable to start the subscription. Please try again.');
                return;
            }

            var data = result.body.data;
            // payment_url carries the Cashfree subscription_session_id.
            var subsSessionId = data.payment_url;
            var cfMode = page.dataset.cfMode || 'production';

            if (!subsSessionId) {
                setBusy(false);
                showError('No mandate session received. Please try again.');
                return;
            }

            try {
                var cashfreeInstance = Cashfree({ mode: cfMode });
                cashfreeInstance.subscriptionsCheckout({
                    subsSessionId: subsSessionId,
                    redirectTarget: '_self'
                });
            } catch (cfErr) {
                console.error('Cashfree mandate checkout error:', cfErr);
                setBusy(false);
                showError('Cashfree checkout failed. Please try again.');
            }
        })
        .catch(function (err) {
            console.error('Subscription initiate failed:', err);
            setBusy(false);
            showError('Network error. Please check your connection and try again.');
        });
    });

    // The free-trial button (#subscribe-trial-btn) is handled by an inline
    // script in subscribe.php — its section renders below the checkout and
    // must work even when this bundle is stale on a host.

    refreshButtonState();
})();
